const getters = {
	origin: () => process.env.VUE_APP_SPACEIN_API_SEARCH_URL,
	pathPrefix: () => '/search-api/search'
}

const actions = {
	request({dispatch, getters}, data) {
		return dispatch('api/requests/sendAxiosRequest', {
			...data,
			url: getters.origin+getters.pathPrefix+data.url,
		}, {root: true});
	},

	usersInArea({dispatch, rootGetters}, query) {
		let currentUsersRoomId = rootGetters.getCurrentUsersRoomId
		let ifInHub = rootGetters.getIfCurrentUsersRoomIsHub
		return dispatch('request', {
			url: `/users`,
			method: 'get',
			params: {
				areaId: rootGetters.getCurrentAreaId,
				query,
				spaceId: ifInHub ? '' : currentUsersRoomId,
				pageSize: 5
			}
		})
	},

	roomParticipants({rootGetters, dispatch}, [id, pageNum]) {
		return dispatch('request', {
			url: `/participants`,
			method: 'get',
			params: {
				areaId: rootGetters.getCurrentAreaId,
				spaceId: id,
				pageSize: 30,
				pageNum
			}
		})
	},
	spacePortalParticipants({dispatch}, [areaId, pageNum]) {
		return dispatch('request', {
			url: `/participants`,
			method: 'get',
			params: {
				areaId: areaId,
				spaceId: '',
				pageSize: 30,
				pageNum
			}
		})
	}

}

export default {
	namespaced: true,
	actions,
	getters
};
